import { StandardItemModel } from "./basic.model"

export class FeedbackModel {
    id: number
    title: string
    point:StandardItemModel
    point_value:number
    s_feedback: number
    s_feedback_value: string
    description: string
    rating: number
    tracking_id: string
    created_by: number
    modified_by: number
    application: number
    attachment:any[]
    task_comment:[TaskCommentModal]
    created_at:string 
    modified_at:string
    type:number
    task:number
    assigned_to:number
    assigned_user:[StandardItemModel]
    
    template_data: FeedbackTemplateData
    status: FeedbackStatusModel
}

export class FeedbackStatusModel {
    id: number
    name: string
    task: boolean
    hexcolor: string
}
export class TaskCommentModal {
    comment:string
    created_at:string }

export class FeedbackResponseModel {
    count: number
    next: string
    previous: string
    results: [FeedbackModel]
}
export class FeedbackIndResponseModel {
    count: number
    next: string
    previous: string
    results: FeedbackModel
}

export class FeedbackFilterModel {
    status_order :boolean
    type_order :boolean
    title_order :boolean
    assigned_to_order :boolean
    date_order :boolean
    ascend:boolean
    descend :boolean
    app_name:number
    submitted_by:number
    assigned_to:number
    type:number
    title:string
    f_task:boolean
    status:number
}


export class FeedbackTemplateData {
    status_name: string
    status_color: string
    priority_name: string
    priority_color: string
    progress_color: string
    application_name: string
    assigned_to_name: string
    created_by_name: string
    assigned_user_name:string
}
export class FeedbackPointsModal {
    results:[StandardPointsModal]
}

export class StandardPointsModal {
    name:string
    sum:number
}
